import Service from '@ember/service';
import { ApplicationType } from '@square/dashboard-protos/models/squareup/devices/external/application_type';
import { GetDeviceRequest, ListDevicesRequest, GetDeviceResponse, ListDevicesResponse, SearchDevicesRequest, SearchDevicesResponse, DeleteDeviceRequest, DeleteDeviceResponse, BatchDeleteDevicesRequest, BatchDeleteDevicesResponse, BatchRetrieveDevicesRequest, BatchRetrieveDevicesResponse, SendDeviceActionResponse, SendDeviceActionRequest } from '@square/dashboard-protos/models/squareup/devices/external/devices_service';
import { createConnectV2Client } from '@square/dashboard-utilities/clients/connect-v2';
const devicesApiConnectV2UrlPrefix = '/v2/devices';
const devicesApiEndpointDefinitions = {
  getDevice: {
    method: 'GET',
    path: '/{deviceId}',
    request: GetDeviceRequest,
    response: GetDeviceResponse
  },
  listDevices: {
    method: 'GET',
    path: '',
    request: ListDevicesRequest,
    response: ListDevicesResponse
  },
  searchDevices: {
    method: 'POST',
    path: '/search',
    request: SearchDevicesRequest,
    response: SearchDevicesResponse
  },
  deleteDevice: {
    method: 'DELETE',
    path: '/{deviceId}',
    request: DeleteDeviceRequest,
    response: DeleteDeviceResponse
  },
  batchDeleteDevices: {
    method: 'POST',
    path: '/batch-delete',
    request: BatchDeleteDevicesRequest,
    response: BatchDeleteDevicesResponse
  },
  batchRetrieveDevices: {
    method: 'POST',
    path: '/batch-retrieve',
    request: BatchRetrieveDevicesRequest,
    response: BatchRetrieveDevicesResponse
  },
  sendDeviceAction: {
    method: 'POST',
    path: '/actions',
    request: SendDeviceActionRequest,
    response: SendDeviceActionResponse
  }
};
export default class DevicesV2Service extends Service {
  get client() {
    return createConnectV2Client(devicesApiEndpointDefinitions, devicesApiConnectV2UrlPrefix);
  }
  searchDevices(request) {
    return this.client.searchDevices(request);
  }
  async doesSellerHaveActiveKdsDevices() {
    try {
      const {
        totalCount
      } = await this.searchDevices(SearchDevicesRequest.create({
        query: {
          filter: {
            applicationTypes: [ApplicationType.KDS]
          }
        },
        limit: 1
      }));
      return totalCount > 0;
    } catch {
      return false;
    }
  }
}